<template>
  <div>
    <v-card-text>
      <div class="banner">
        <h4>{{ orgonData.menuItem.title }} {{ orgonData.orgon.name }}</h4>
      </div>

      <v-form @submit.prevent="form" ref="form" :disabled="disableForm">
        <v-row no-gutters v-if="['EDITAR STATUS'].includes(orgonData.menuItem.title)">
          <v-col cols="12" class="text-center">
            <span class="text-center">
              {{ $t('inputs.orgons_captureds.orgon_status') }}
            </span>
          </v-col>

          <v-col cols="12" class="d-flex justify-center">
            <v-radio-group
             data-cy="status-orgao"
              v-model="statusOption" 
              @change="changeStatusOptions"
              color="success"
              row
              dense
              class="d-flex justify-center"
            >
              <v-radio
              data-cy="status-descartado"
                :label="$t('inputs.orgons_captureds.discard')"
                value="DESCARTADO"
                color="#086318"
                class="mr-4"
                dense
              />
              <v-radio
              data-cy="status-transplantado"
                :label="$t('inputs.orgons_captureds.transplant')"
                value="TRANSPLANTADO"
                color="#086318"
                class="mr-4"
                dense
              />
              <v-radio
               data-cy="status-disponibilizado"
                :label="$t('inputs.orgons_captureds.disponibilization')"
                value="DISPONIBILIZADO"
                color="#086318"
                dense
              />
            </v-radio-group>
          </v-col>
        </v-row>
        <v-row no-gutters>    
          <v-col cols="12" class="pr-2" :sm="isTransplantStatus ? '12' : '6'"
           v-if="!['DESCARTE'].includes(orgonData.menuItem.slug)"> 
            <v-text-field 
                data-cy="rgct"
                color="#086318" 
                v-model="orgonForm.rgct_receiver"
                class="rounded-lg" 
                v-mask="'######-####'"
                :rules="formRules" 
                maxlenght="11"
                dense 
                outlined>
                <template v-slot:label>
                    {{ $t('inputs.orgons_captureds.rgct') }} <span style="color: red;">*</span>
                </template>
            </v-text-field>  
          </v-col>
          <v-col cols="12" sm="6" v-if="isAvailableStatus"> 
            <v-autocomplete 
             data-cy="estado"
                :items="states"
                color="#086318" 
                :rules="formRules" 
                v-model="orgonForm.state"
                class="rounded-lg"
                item-value="nome"
                item-text="nome" 
                dense 
                outlined>
                <template v-slot:label>
                    {{ $t('inputs.orgons_captureds.state') }} <span style="color: red;">*</span>
                </template>
            </v-autocomplete>  
          </v-col> 
          <v-col cols="12" sm="12" v-if="isTransplantStatus"> 
            <v-select 
             data-cy="centro-transplantador"
                :items="centers"
                color="#086318" 
                v-model="orgonForm.center_transplanter_id"
                class="rounded-lg"
                item-value="id"
                item-text="hospital" 
                :rules="formRules" 
                dense 
                outlined>
                <template v-slot:label>
                    {{ $t('inputs.orgons_captureds.transplanter_center') }} <span style="color: red;">*</span>
                </template>
            </v-select>  
          </v-col> 
          
          <v-col
            cols="12"
            sm="12"
            v-if="showCorneasForm"
            class="d-flex flex-column align-center">

            <span class="text-center">{{ $t('messages.item_discarted') }}<span style="color:red">*</span></span>

            <v-radio-group data-cy="tipo-cornea" v-model="fabric_type_id" row :rules="formRules" class="justify-center">
              <v-radio data-cy="globo" :label="$t('inputs.orgons_captureds.globe')" value="1" color="success" ></v-radio>
              <v-radio data-cy="cornea" :label="$t('inputs.orgons_captureds.cornea')" value="2" color="success" ></v-radio>
            </v-radio-group>
          </v-col>

          <v-col cols="12" sm="12" v-if="!isTransplantStatus"> 
            <v-select 
            data-cy="motivo"
                :items="reasons"
                color="#086318"  
                :rules="formRules" 
                v-model="orgonForm.reason_id"
                class="rounded-lg"
                item-value="id"
                item-text="description" 
                dense 
                outlined>
                <template v-slot:label>
                    {{ $t('inputs.orgons_captureds.reason') }} {{ action }} <span style="color: red;">*</span>
                </template>
            </v-select>  
          </v-col> 
          <v-col cols="12" sm="12" v-if="[9, 10].includes(orgonForm.reason_id)"> 
            <v-text-field  
            data-cy="descricao-motivo"
                color="#086318" 
                v-model="orgonForm.description_reason_other"
                class="rounded-lg" 
                dense 
                :rules="formRules" 
                outlined>
                <template v-slot:label>
                    {{ $t('inputs.orgons_captureds.describe') }} <span style="color: red;">*</span>
                </template>
            </v-text-field>  
          </v-col> 
        </v-row>
      </v-form> 
        <v-row dense class="d-flex justify-center">
            <v-btn
              data-cy="salvar-status-orgao"
             v-if="orgonData.menuItem.title != 'VISUALIZAR'"
            class="rounded-lg"
            :loading="loading"
            elevation="0"
            color="#41916b"
            small
            @click="submitForm()"
            >
            <span style="color: white">{{ orgonData.menuItem.action == 'edit' ? $t('buttons.to_update') : $t('buttons.save') }}</span>
            </v-btn>
            <v-btn
              data-cy="cancelar-status-orgao"
            class="rounded-lg ml-1"
            elevation="0"
            color="white"
            small
            text
            outlined
            @click="closeDialog()"
            >
            <span style="color: #41916b">{{$t('buttons.cancel')}}</span>
            </v-btn>
        </v-row> 
    </v-card-text>
  </div>
</template>
<script>
import axios from "@/axios";
import { mapGetters, mapActions } from "vuex";
import { getStates } from "@/service/FormFieldsService";
export default {
  data() { 
    return {
      orgonForm: {},
      action: '',
      states: [],
      centers: [],
      reasons: [],
      formRules: [(v) => !!v || this.$t('messages.required_field')],
      loading: false,
      disableForm: false,
      fabric_type_id: null,
      statusOption: "",
      isChangingStatus: false
    };
  },

  created() {
    this.getStates();
  },

  computed: {
    ...mapGetters({
        orgonData: "getOrgonsData",  
    }),

    isTransplantStatus() {
      return this.orgonData.menuItem.slug === 'TRANSPLANTE';
    },

    isAvailableStatus() {
      return this.orgonData.menuItem.slug === 'DISPONIBILIZACAO';
    },

    isDiscardedStatus() {
      return this.orgonData.menuItem.slug === 'DESCARTE';
    },
 
    showCorneasForm(){
      return ( 
        !['TRANSPLANTE', 'DISPONIBILIZACAO'].includes(this.orgonData.menuItem.slug) &&
        ['DESCARTAR', 'VISUALIZAR', 'EDITAR STATUS'].includes(this.orgonData.menuItem.title) &&
        ['CÓRNEA DIREITA', 'CÓRNEA ESQUERDA'].includes(this.orgonData.orgon.name)
      );
    }
  },

  watch: {
    orgonData: {
      handler(item) {
        if(this.isChangingStatus) { 
          this.isChangingStatus = false;
          this.loadDependencies();
          return;
        }

        this.loadDependencies();
        this.initForm(item);
      },
      deep: true,
       immediate: true
    }
  },

  methods: {
    ...mapActions([ 
        "changeSnackBarData"
    ]),

    loadDependencies() {
      this.getCenters();
      this.getReasons();
    },

    initForm(item) {       
      this.disableForm = item.menuItem.action === 'view';
      this.orgonForm = { ...item.view };

      this.statusOption =
        item.view &&
          item.view.availabillity_status
          ? item.view.availabillity_status.description
          : '';

      this.setAction(item);
      this.fillFieldsByMenu(item);
    },
 
    setAction(item) {
      this.action =
        item.menuItem.title === 'DESCARTAR'
          ? 'Descarte'
          : 'Disponibilização';
    },

    fillFieldsByMenu(item) {  
      const slug = item.menuItem.slug;

      if(slug === 'TRANSPLANTE') {
        this.orgonForm.center_transplanter_id =
          item.view.center_transplanter_id
            ? parseInt(item.view.center_transplanter_id)
            : null;
         this.orgonForm.rgct_receiver = item.view.rgct_receiver || null;
      }

      if(slug === 'DISPONIBILIZACAO') {
        this.orgonForm.rgct_receiver = item.view.rgct_receiver || null;
        this.orgonForm.state = item.view.state || null;
        this.orgonForm.reason_id = item.view.reason_id
          ? parseInt(item.view.reason_id)
          : null;
        this.orgonForm.description_reason_other =
          item.view.description_reason_other || null;
      }

      if(slug === 'DESCARTE') {
        this.orgonForm.reason_id = item.view.reason_id
          ? parseInt(item.view.reason_id)
          : null;

        this.fabric_type_id = item.view.fabric_type_id ?? null;
      }
    },

    async getStates() { 
      this.states =   await getStates();
    },

    changeStatusOptions() {
      this.isChangingStatus = true; 

      switch (this.statusOption) {
        case 'DESCARTADO':
          this.orgonData.menuItem.slug = 'DESCARTE';
          break;

        case 'TRANSPLANTADO':
          this.orgonData.menuItem.slug = 'TRANSPLANTE';
          break;

        case 'DISPONIBILIZADO':
          this.orgonData.menuItem.slug = 'DISPONIBILIZACAO';
          break;
      }

      this.clearFormFields();
    },

    clearFormFields() {
      this.orgonForm.state = null;
      this.orgonForm.center_transplanter_id = null;
      this.orgonForm.reason_id = null;
      this.orgonForm.rgct_receiver = null;
      this.orgonForm.description_reason_other = null;
      this.fabric_type_id = null; 

      this.$refs.form.resetValidation();
    },

    getCenters() {
      axios.get(`/unities/filter`, { params: {
        orgon_name: this.orgonData.orgon.name  
      }}).then((response) => {
        this.centers = response.data.data ? response.data.data : response.data;
      }).catch(() => { 
        this.centers = []; 
      });
    }, 

    async getReasons(){
      axios.get(`/reasons/filter`, { params: {
        availabillity_status_id:  await this.findAvailabilityIdByStatus(this.orgonData.menuItem.slug),
        type_orgon_id: this.orgonData.orgon.type_orgon_id == '2' ? 2 : null
      }}).then((response) => {
        this.reasons = response.data.data ? response.data.data : response.data;
      }).catch(() => { 
        this.reasons = []; 
      });
    },

    async submitForm(){
       if(this.$refs.form.validate()) { 
         this.loading = true;   
 
         let data = {
            orgon_captured_id: this.orgonData.orgon_captured_id,
            state: [
              'DISPONIBILIZACAO'
            ].includes(this.orgonData.menuItem.slug) ? this.orgonForm.state : null,
            center_transplanter_id: [
              'TRANSPLANTE'
            ].includes(this.orgonData.menuItem.slug) ? this.orgonForm.center_transplanter_id : null,
            reason_id: [
              'DISPONIBILIZACAO',
              'DESCARTE'
            ].includes(this.orgonData.menuItem.slug) ? this.orgonForm.reason_id : null,
            availabillity_status_id: await this.findAvailabilityIdByStatus(this.orgonData.menuItem.slug),
            rgct_receiver: [
              'DISPONIBILIZACAO', 
              'TRANSPLANTE'
            ].includes(this.orgonData.menuItem.slug) && this.orgonForm.rgct_receiver ? this.orgonForm.rgct_receiver.replace(/-/g, "") : null,
            description_reason_other: [
              'DESCARTE'
            ].includes(this.orgonData.menuItem.slug) ? this.orgonForm.description_reason_other : null,
            fabric_type_id: [
              'DESCARTE',
              'EDITAR STATUS'
            ].includes(this.orgonData.menuItem.slug) ? this.fabric_type_id : null
         }

          axios({
            method: this.orgonData.menuItem.action == 'edit' ? "PUT" : "POST",
            url: this.orgonData.menuItem.action == 'edit'
              ? `/availability/${this.orgonData.view.id}`
              : `/availability/create`,
            data: data,
          }).then((response) => {
                this.loading = false;   
                
                this.changeSnackBarData({
                    status: true,
                    type: 'success', 
                    titleMessage: response.data.message,
                    bodyMessage: '',
                    cardColor: 'success',
                    titleIcon: 'mdi-check-circle',
                });

                setTimeout(() => {
                    this.orgonForm = {}
                    this.closeSnackBar();
                    this.$emit('loadTable');
                    this.$emit('closeDialog'); 
                    this.$refs.form.resetValidation();
                }, 3000);

            }).catch((err) => {
              this.loading = false;

              let msg = "";

              if (err.details && typeof err.details === "object") {
                  msg = Object.values(err.details)
                      .flat()
                      .join("\n");
              } else if (err.error) {
                  msg = err.error;
              }

              this.changeSnackBarData({
                  status: true,
                  type: 'erro',
                  titleMessage: this.$t('messages.something_went_wrong'),
                  bodyMessage: msg,
                  cardColor: 'red',
                  titleIcon: 'mdi-close-circle',
              });

              setTimeout(() => {
                  this.closeSnackBar();
              }, 5000);
          }); 
       }
    }, 

    async findAvailabilityIdByStatus(slug) {
      try {
        const response = await axios.get('/availabillity_status/list_availabillity_status'); 
        const list = response.data.data ?? response.data;

        const mappedStatus = this.mapStatusToPast(slug);

        if(!mappedStatus) return null;

        const availability = list.find(
          (item) => item.slug?.toLowerCase() == mappedStatus
        );

        return availability ? availability.id : null;

      }catch(err) {
        return null;
      }
    },

    mapStatusToPast(slug) {
      const statusMap = {
        TRANSPLANTE: 'transplantado',
        DISPONIBILIZACAO: 'disponibilizado',
        DESCARTE: 'descartado',
      };

      return statusMap[slug] || null;
    },
     
    closeDialog() {
      this.orgonForm = {};
      this.$refs.form.resetValidation();
      this.disableForm = false;
      this.$emit('closeDialog');
      this.isChangingStatus = false;
    },

    closeSnackBar(){
        this.changeSnackBarData({
            status: false,
            type: '', 
            titleMessage: '',
            bodyMessage: '',
            cardColor: '',
            titleIcon: '',
        });
    }
  },
};
</script>
<style scoped> 
.banner {
  background: #b3ffab;
  /* fallback for old browsers */
  background: -webkit-linear-gradient(to right,
      #41916b,
      #1abc9c);
  /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(to right,
      #41916b,
      #b8e0cd);
  /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */

  border-radius: 8px;

  margin-bottom: 10px;

  display: flex;
  align-items: center;
}

.banner>h4 {
  color: #ffffff;
  padding: 10px;
}
</style>
